import Vue from 'vue';
import App from './App.vue';
import { router } from './router';
import store from '@adobe/edex/frontend/store';

import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import VueMeta from 'vue-meta';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
import VModal from 'vue-js-modal';
import * as FullStory from '@fullstory/browser';
import AsyncComputed from 'vue-async-computed';

import VueObserveVisibility from 'vue-observe-visibility';
import VueMasonry from 'vue-masonry-css';

import { directive as onClickOutside } from 'vue-on-click-outside';

import { buildLink, rDecor, lzDateFmt, getStaticPageIDs } from '@adobe/edex/frontend/mixins/i18n';
import constants from '@adobe/edex/frontend/mixins/constants';
import { VueSilentbox } from '@adobe/edex/frontend/components/common/vue-silentbox';
import saveAs from 'file-saver';
import { vueI18n } from '@adobe/edex/ui/shared/services/i18n';
import { replaceCdnHost } from '@adobe/edex/ui/shared/frontend/utils/cdn';

import '@adobe/edex/frontend/styles/application.scss';
import ical from 'ical-generator';
import Toasted from 'vue-toasted';
import ToggleButton from 'vue-js-toggle-button';
import { getAvatarURL } from '@adobe/edex/ui/shared/utils';

import { EdexOneTrust } from '@adobe/edex/ui/shared/config/onetrust';
import { IMS } from '@adobe/edex/ui/shared/config/ims';
import { initWcsLocale } from '@adobe/edex/ui/shared/config/i18n';
import Clipboard from 'v-clipboard';

Vue.use(VueSilentbox);
Vue.use(VueMasonry);
Vue.use(Toasted, {
  position: 'bottom-center',
  duration: 5000,
  singleton: true,
});
Vue.use(VModal, { dialog: true });
Vue.use(ToggleButton);
Vue.use(VueMeta, {
  keyName: 'seo',
});
Vue.use(VueMoment, {
  moment,
});
Vue.use(VueObserveVisibility);
Vue.use(AsyncComputed);
Vue.use(Clipboard);

Vue.directive('on-click-outside', onClickOutside);

Vue.prototype.ical = ical;
Vue.prototype.saveAs = saveAs;
Vue.prototype.constants = constants;
Vue.prototype.buildLink = buildLink;
Vue.prototype.rDecor = rDecor; // decorate link routes
Vue.prototype.lzDateFmt = lzDateFmt;
Vue.prototype.getStaticPageIDs = getStaticPageIDs;
Vue.prototype.stripHTML = (input) => input.replace(/<[^>]*>?/gm, '');
Vue.prototype.getAvatarURL = getAvatarURL;

// FullStory
Vue.prototype.$FullStory = FullStory;

// Dynamic replacement of the cdn host in templates
Vue.prototype.$cdn = replaceCdnHost;

Vue.config.productionTip = false;

async function bootstrap() {
  await initWcsLocale();
  new Vue({
    el: '#app',
    i18n: vueI18n,
    router,
    store,
    render: (h) => h(App),
  });
  IMS.bootstrap();
  await Promise.resolve();
  EdexOneTrust.bootstrap();
}

bootstrap().catch(console.error);
